"use strict";

/**
 * If you wish to import a new JS library, you
 * should add it to the project via "npm install"
 * and then import it below.
 */

// node_modules imports.
//

// Vendor imports.
import './vendor/picturefill';
import './vendor/lazysizes';
import './vendor/simplelightbox';
import './vendor/skip-link-focus-fix';

// Navigation
import './global/navigation';

// Class Imports
import TextHero from './classes/TextHero';
import StudentAnimation from './classes/StudentAnimation';
import StaffStrip from './classes/StaffStrip';
import ImageReveal from './classes/ImageReveal';
import FadeUp from './classes/FadeUp';
import ScrollingText from './classes/TextScroll';
import FeaturedStrip from './classes/FeaturedStrip';
import TextLinksStrip from './classes/TextLinksStrip';
import ThumbnailCarousel from './classes/ThumbnailCarousel';
import GalleryCarousel from './classes/GalleryCarousel';

// block imports
import './blocks/extended-grid';

import { Swiper, Navigation, Pagination, EffectFade, Mousewheel, Autoplay } from 'swiper';


window.onload = () => {

	let headerContactLink = document.querySelector(".site-header__contact");

	const expandMobileContactMenu = (e) => {

		if (window.innerWidth < 992) {
			e.preventDefault();

			if (headerContactLink.classList.contains("active")) {
				headerContactLink.classList.remove("active");
			} else {
				headerContactLink.classList.add("active");
			}

			let headerContactMenu = document.querySelector(".site-header__mobile-contact-menu");

			if (headerContactMenu !== null) {
				if (headerContactMenu.classList.contains("active")) {
					headerContactMenu.classList.remove("active");
				} else {
					headerContactMenu.classList.add("active");
				}
			}
		} else {
			let linkLocation = this.href;
			window.location.href = linkLocation;
		}
	}

	if (headerContactLink !== null) {
		headerContactLink.addEventListener("click", expandMobileContactMenu);
	}


	// Default ScrollTrigger Settings
	gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
	document.addEventListener('lazyloaded', function(e){
		ScrollTrigger.refresh();
	});

	// Text Hero
	let textHero = document.querySelector(".block-text-hero");
	if ( textHero !== null ) {
		new TextHero(textHero);
	}

	// Student Animation
	let studentAnimation = document.querySelector(".block-student-animation");
	if ( studentAnimation !== null ) {
		new StudentAnimation(studentAnimation);
	}

	// Staff Strip
	let staffStrip = document.querySelector(".block-staff-strip");
	if ( staffStrip !== null ) {
		new StaffStrip(staffStrip);
	}

	let textLinksStrip = document.querySelector(".block-text-and-links-list");
	if ( textLinksStrip !== null ) {
		new TextLinksStrip(textLinksStrip);
	}

	// Image Reveal Animation
	let imageReveals = document.querySelectorAll(".js-reveal");
	if ( imageReveals !== null ) {
		imageReveals.forEach((image) => {
			new ImageReveal(image);
		});
	}

	// Fade up Animation
	let fadeUps = document.querySelectorAll(".js-fade-up");
	if ( fadeUps !== null ) {
		fadeUps.forEach((image) => {
			new FadeUp(image);
		});
	}

	// Scrolling Text
	let scrollingText = document.querySelectorAll(".js-scroll-text");
	if ( scrollingText !== null ) {
		scrollingText.forEach((text) => {
			new ScrollingText(text);
		});
	}

	let featuredStrip = document.querySelector(".block-featured-strip");
	if ( featuredStrip !== null ) {
		new FeaturedStrip(featuredStrip);
	}

	// Image Reveal Animation
	let thumbnailCarousels = document.querySelectorAll(".block-thumbnail-carousel");
	if ( thumbnailCarousels !== null ) {
		thumbnailCarousels.forEach((carousel) => {
			new ThumbnailCarousel(carousel);
		});
	}

	// Image Reveal Animation
	let galleryCarousels = document.querySelectorAll(".block-gallery-carousel");
	if ( galleryCarousels !== null ) {
		galleryCarousels.forEach((carousel) => {
			new GalleryCarousel(carousel);
		});
	}


	// SHIELD MASK
	let shieldMask = document.querySelector(".block-shield-mask");

	if ( shieldMask !==null ) {

		var animateMask02 = gsap.timeline();
		var lineAnimate = animateMask02.fromTo(".block-shield-mask__line", {height: 0}, {height: "40%"});

		ScrollTrigger.create({
			trigger: ".block-shield-mask__line-wrap",
			start: "top 50%",
			end: "top top",
			scrub: true,
			animation: lineAnimate,
			toggleActions: "play pause reverse reset",
		});

		var animateMask03 = gsap.timeline();
		var fadeLine = animateMask03.fromTo(".block-shield-mask__line", {autoAlpha: 1}, {autoAlpha: 0});

		ScrollTrigger.create({
			trigger: shieldMask,
			start: "top top",
			end: "+=40",
			scrub: true,
			animation: fadeLine,
			toggleActions: "play none reverse reset",
		});

		var animateMask = gsap.timeline();
		var tween;

		if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
		 	tween = animateMask.fromTo(".block-shield-mask__mask", {scale: 1, force3D: false}, {scale: 70, force3D: false});
		} else {
			tween = animateMask.fromTo(".block-shield-mask__mask", {scale: 1}, {scale: 70});
		}

		ScrollTrigger.create({
			trigger: shieldMask,
			start: "top top",
			end: "bottom top",
			scrub: true,
			pin: true,
			anticipatePin: 1,
			pinSpacing: false,
			animation: tween,
		});

		// ScrollTrigger.create({
		// 	trigger: shieldMask,
		// 	start: "top top",
		// 	end: "bottom top",
		// 	scrub: true,
		// 	// pin: true,
		// 	// anticipatePin: 1,
		// 	// pinSpacing: false,
		// 	// force3D: false,
		// 	animation: tween,
		// });

		// ScrollTrigger.create({
		// 	trigger: ".block-shield-mask__mask",
		// 	start: "top top",
		// 	end: "bottom top",
		// 	scrub: true,
		// 	animation: tween,
		// 	toggleActions: "play pause reverse reset",
		// });

	}



	let tabsContainer = document.querySelector(".block-text-and-tabs__tabs");

	if ( tabsContainer !== null ) {
		let tabs = tabsContainer.querySelectorAll(".block-text-and-tabs__tab");
		let tabSections = document.querySelectorAll(".block-text-and-tabs__content");

		tabs.forEach((tab) => {

			tab.addEventListener("click", function() {

				tabs.forEach((tab) => {
					tab.classList.remove("block-text-and-tabs__tab--active");
				});
				this.classList.add("block-text-and-tabs__tab--active");

				tabSections.forEach((section) => {
					section.classList.remove("block-text-and-tabs__content--active");
				});

				let tabTarget = this.getAttribute('data-tab-target');
				let selectedTab = document.querySelector(tabTarget);

				selectedTab.classList.add("block-text-and-tabs__content--active");

			});

		});
	}

	Swiper.use( [ Navigation, Pagination, EffectFade, Mousewheel, Autoplay ] );

	var swiper = new Swiper(".mySwiper", {
		autoHeight: true,
		loop: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	let carouselWrap = document.querySelector(".block-overlapping-content__carousel-wrap");

	if (carouselWrap !== null) {
		function moveCarousel() {
			let contentColumn = document.querySelector(".block-overlapping-content__content-column");
			let imageColumn = document.querySelector(".block-overlapping-content__background");
			let carouselComponent = document.querySelector(".block-overlapping-content__carousel-wrap");

			if (window.innerWidth < 768) {
				contentColumn.appendChild(carouselComponent);
			} else {
				imageColumn.appendChild(carouselComponent);
			}
		}

		moveCarousel();
		window.addEventListener('resize', function(event){
			moveCarousel();
		});
	}

	let sideContent = document.querySelector(".block-content-block__sidebar-content");
	let sideContentForm = document.querySelector(".block-content-block__form");

	if (sideContent !== null && sideContentForm === null) {

		ScrollTrigger.matchMedia({
			"(min-width: 1200px)": function() {
				ScrollTrigger.create({
					trigger: ".block-content-block",
					pin: sideContent,
					start: "top top",
					end: "bottom 90%",
					toggleClass: {targets: ".block-content-block__sidebar-content", className: "active"}
				});
			},
		  });
	}

	// SEARCH FUNCTIONALITY
	let searchTrigger = document.querySelector(".site-header__search");

	if (searchTrigger !== null) {

		searchTrigger.addEventListener("click", expandSearch);

		function expandSearch() {

			let searchPanel = document.querySelector(".site-header__search-panel");

			if (searchPanel !== null) {

				if (searchPanel.classList.contains("active")) {
					searchTrigger.classList.remove("active");
					searchPanel.classList.remove("active");
				} else {
					searchTrigger.classList.add("active");
					searchPanel.classList.add("active");
					document.querySelector("#site-navigation").classList.remove("--expand");
					document.querySelector(".site-header__menu-toggle").classList.remove("--expand");
				}

			}
		}
	}

	// CARD HEIGHTS

	let articleCards = document.querySelectorAll(".block-filterable-item-grid__card");

	if (articleCards !== null) {

		function setCardInnerHeight() {
			let heights = [];

			articleCards.forEach((card) => {
				let cardInner =  card.querySelector(".block-filterable-item-grid__card-inner");
				cardInner.style.height = "auto";

				let cardInnerHeight = card.querySelector(".block-filterable-item-grid__card-inner").offsetHeight;
				heights.push(cardInnerHeight);
			});

			let tallestHeight = Math.max.apply(Math, heights);

			articleCards.forEach((card) => {
				let cardInner =  card.querySelector(".block-filterable-item-grid__card-inner");
				cardInner.style.height = tallestHeight + "px";
			});
		}

		// setCardInnerHeight();
		// window.addEventListener('resize', function(event){
		// 	setCardInnerHeight();
		// });
	}



	function shieldSize(el) {
		let shieldWidth = 27;
		let shieldHeight = 29;
		let pattern = el;

		if (pattern !== null) {
			let patternHeight = pattern.offsetHeight;
			let patternWidth = pattern.offsetWidth;
			let calcHeight = Math.ceil(patternHeight/shieldHeight) * shieldHeight;
			let calcWidth = Math.ceil(patternWidth/shieldWidth) * shieldWidth;

			pattern.style.height = calcHeight + 'px';
			pattern.style.width = calcWidth + 'px';
		}
	}

	let patterns = document.querySelectorAll(".js-pattern");

	if (patterns !== null) {
		patterns.forEach((pattern) => {
			shieldSize(pattern);
		});
	}


	let accordionBlocks = document.querySelectorAll(".block-vacancies-accordion");

	if (accordionBlocks !== null) {
		accordionBlocks.forEach((component) => {

			let accordionPanels = component.querySelectorAll(".block-vacancies-accordion__panel");

			if (accordionPanels !== null) {
				accordionPanels.forEach((panel) => {
					let panelTitle = panel.querySelector(".block-vacancies-accordion__panel-title");
					let panelBody = panel.querySelector(".block-vacancies-accordion__panel-body");


					panelBody.anim = gsap.to(panelBody, {
						duration: 0.8,
						// ease: "elastic.inOut(1, 0.5)",
						paused: true,
						marginTop: 0,
						height: "auto",
						autoAlpha: 1,
					});

					panelTitle.addEventListener('click', function(event){

						let parentPanel = this.parentElement;

						if (parentPanel.classList.contains("active")) {
							parentPanel.classList.remove("active");
							panelBody.anim.reverse();
						} else {
							parentPanel.classList.add("active");
							panelBody.anim.play();
						}

					});
				});
			}

		});
	}

	var ppp = 10; // Post per page
	var pageNumber = 1;

	function load_posts(){
		pageNumber++;
		var query = jQuery('input[name="query"]').val();
		var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_post_ajax&query=' + query;

		jQuery.ajax({
			type: "POST",
			dataType: "html",
			url: '/wp/wp-admin/admin-ajax.php',
			data : str,
			success: function(data){
				var $data = jQuery(data);
				if($data.length){
					jQuery("#more-posts-container .row").append($data);
					jQuery("#more-search-posts").attr("disabled",false);
				} else{
					jQuery("#more-search-posts").attr("disabled",true);
				}
			},

		});
		return false;
	}

	jQuery("#more-search-posts").on("click",function(e){ // When btn is pressed.
		e.preventDefault();
		jQuery("#more-search-posts").attr("disabled",true); // Disable the button, temp.
		load_posts();
	});


	let resultsBlockComponents = document.querySelectorAll(".block-results-grid");

	if (resultsBlockComponents !== null) {
		resultsBlockComponents.forEach((component) => {

			let resultsSwitcher = component.querySelector(".e-dropdown");

			if (resultsSwitcher !== null) {

				function displayResults() {
					// let selectedValue = this.value;
					let selectedValue = component.querySelector('input[name="year"]:checked').value;
					let selectedID = component.querySelector('input[name="year"]:checked').id;
					let selectedLabel = component.querySelector("[for='" + selectedID +"']").textContent;
					let selectedBlock = component.querySelector('#' + selectedValue);
					let yearBlocks = component.querySelectorAll(".block-results-grid__year-block");

					yearBlocks.forEach((block) => {
						block.classList.remove("active");
					});

					selectedBlock.classList.add("active");

					this.classList.remove("active");
					this.querySelector(".e-dropdown__placeholder").textContent = selectedLabel;
				}

				resultsSwitcher.addEventListener("change", displayResults);
			}

		});
	}


	let socialMediaGrids = document.querySelectorAll(".block-social-media-grid");;

	if (socialMediaGrids !== null) {
		socialMediaGrids.forEach((component) => {

			let socialCarousel = component.querySelector(".block-social-media-grid__carousel");

			if (socialCarousel !== null) {
				var carousel = new Swiper(socialCarousel, {
					loop: false,
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 20,
					breakpoints: {
						768: {
						  slidesPerView: 2,
						  slidesPerGroup: 2,
						},
						992: {
						  slidesPerView: 3,
						  slidesPerGroup: 3,
						},
					},
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
					navigation: {
						nextEl: '.block-social-media-grid-button--next',
						prevEl: '.block-social-media-grid-button--prev',
					  },
				});
			}

		});
	}


	let latestVideoStrips = document.querySelectorAll(".block-latest-videos-strip");

	if (latestVideoStrips !== null) {
		latestVideoStrips.forEach((component) => {

			let videoCarousel = component.querySelector(".block-latest-videos-strip__carousel");

			var swiper = new Swiper(videoCarousel, {
				loop: false,
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 20,
				breakpoints: {
					768: {
					  slidesPerView: 2,
					  slidesPerGroup: 2,
					},
					992: {
					  slidesPerView: 3,
					  slidesPerGroup: 3,
					},
				},
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: '.block-latest-videos-strip-button--next',
					prevEl: '.block-latest-videos-strip-button--prev',
				  },
			});
		});
	}


	let customDropdowns = document.querySelectorAll(".e-dropdown");

	if (customDropdowns !== null) {
		customDropdowns.forEach((dropdown) => {

			let dropdownTrigger = dropdown.querySelector(".e-dropdown__placeholder");

			dropdownTrigger.addEventListener("click", showDropdownMenu);

			function showDropdownMenu() {
				let parentDropdown = this.parentElement;

				if (parentDropdown.classList.contains("active")) {
					parentDropdown.classList.remove("active");
				} else {
					parentDropdown.classList.add("active");
				}
			}

		});
	}


	// NEWS AND EVENTS FILTERING
	function postsFilter(page_num) {

		jQuery('[name=filtered]').val(1);
		jQuery('input[name=page]').val(1);

		var type = jQuery('[name="type"]:checked').val();

		var categories = [];
		jQuery('[name="categories[]"]:checked').each(function() {
			categories.push(jQuery(this).val());
		});

		var dates = [];
		jQuery('[name="dates[]"]:checked').each(function() {
			dates.push(jQuery(this).val());
		});

		var eventCategories = [];
		jQuery('[name="event-categories[]"]:checked').each(function() {
			eventCategories.push(jQuery(this).val());
		});

		var eventDates = [];
		jQuery('[name="event-dates[]"]:checked').each(function() {
			eventDates.push(jQuery(this).val());
		});

		jQuery.ajax({
			type: 'POST',
			url: '/wp/wp-admin/admin-ajax.php',
			data: {
				action: 'post_filters',
				types: type,
				categories: categories,
				eventcategories: eventCategories,
				dates: dates,
				eventdates: eventDates,
				paged: 1,
			},
			beforeSend: function (xhr) {
				jQuery("#post-results .block-filterable-item-grid__card").css("opacity", "0.5");
			},
		}).done(function (data) {
			jQuery("#post-results .block-filterable-item-grid__card").css("opacity", "1");
			jQuery("#post-results").empty();
			jQuery("#post-results").append(data);
		});
	}

	jQuery('.block-filters input[type=checkbox], .block-filters input[type=radio]').on('change', function() {
		var latestNewsBlocks = jQuery(".block-latest-news-blocks");
		latestNewsBlocks.slideUp();

		jQuery(this).closest(".e-dropdown").removeClass("active");

		postsFilter();
	});

	jQuery('.block-filters input[name=type]').on('change', function() {

		var filters = jQuery(".block-filters .js-filter");

		if (jQuery(this).val() == 'post') {
			filters.each(function() {
				if (jQuery(this).hasClass("js-filter-post")) {
					jQuery(this).show();
				} else {
					jQuery(this).hide();
				}
			});

		} else if (jQuery(this).val() == 'event') {
			filters.each(function() {
				if (jQuery(this).hasClass("js-filter-event")) {
					jQuery(this).show();
				} else {
					jQuery(this).hide();
				}
			});
		}

	});



	function loadMorePosts(page_num, excluded_items) {

		var filteredValue = jQuery('[name=filtered]').val();

		if (filteredValue == '1') {
			excluded_items = null;
		}

		var type = jQuery('[name="type"]:checked').val();

		var categories = [];
		jQuery('[name="categories[]"]:checked').each(function() {
			categories.push(jQuery(this).val());
		});

		var dates = [];
		jQuery('[name="dates[]"]:checked').each(function() {
			dates.push(jQuery(this).val());
		});

		var eventCategories = [];
		jQuery('[name="event-categories[]"]:checked').each(function() {
			eventCategories.push(jQuery(this).val());
		});

		var eventDates = [];
		jQuery('[name="event-dates[]"]:checked').each(function() {
			eventDates.push(jQuery(this).val());
		});

		jQuery.ajax({
			type: 'POST',
			url: '/wp/wp-admin/admin-ajax.php',
			data: {
				action: 'load_more_posts',
				types: type,
				categories: categories,
				eventcategories: eventCategories,
				dates: dates,
				eventdates: eventDates,
				excluded: excluded_items,
				paged: page_num || 1,
			},
			beforeSend: function (xhr) {
				jQuery("#post-results .block-filterable-item-grid__card").css("opacity", "0.5");
			},
		}).done(function (data) {
			jQuery("#post-results .block-filterable-item-grid__card").css("opacity", "1");
			jQuery(".js-load-more").remove();
			jQuery("#post-results").append(data);
			// jQuery("#more-posts").append(data);
		});
	}


	jQuery('#post-results').on( 'click', '.js-load-more', function(e){
		e.preventDefault();
		var paged = jQuery('input[name=page]');
		var pagedValue = parseInt(paged.val());

		var excludedItems = jQuery('input[name=exclude]').val();

		var addPage = pagedValue + 1;
		paged.val(addPage);

		loadMorePosts(addPage, excludedItems);
	});


	jQuery(".wpcf7-submit").attr('title', 'Please ensure you accept the requirements');


	// Run BaguetteBox
	const galleryImages = document.querySelectorAll('.blocks-gallery-item img');
	if (galleryImages) {
		galleryImages.forEach((img) => {
			const wrapper = document.createElement('a');
			wrapper.setAttribute('href', img.getAttribute('src'));
			img.parentNode.appendChild(wrapper);
			wrapper.appendChild(img);
		});

		new SimpleLightbox('.blocks-gallery-grid a');
	}


	function moveAcceptanceBox(strip) {
		let optInMessage = strip.querySelector("#js-opt-in");
		let mobileContainer = strip.querySelector("#js-mobile-opt-in");
		let desktopContainer = strip.querySelector("#js-desktop-opt-in");

		if (optInMessage !== null && mobileContainer !== null && desktopContainer !== null) {
			if (window.innerWidth < 992) {
				mobileContainer.appendChild(optInMessage);
			} else {
				desktopContainer.appendChild(optInMessage);
			}
		}
	}


	let subscribeStrips = document.querySelectorAll(".block-cta-strip");

	if (subscribeStrips !== null) {
		subscribeStrips.forEach((strip) => {

			moveAcceptanceBox(strip);

			window.addEventListener("resize", function(){
				moveAcceptanceBox(strip);
			}, true);

		});
	}


	/**
	 * Listens for the Contact Form 7 plugin mailsent event
	 * Fires when an Ajax form submission has completed successfully, and mail has been sent.
	 * @link https://contactform7.com/dom-events/
	 */
	document.addEventListener('wpcf7mailsent', (event) => {
		const formTitle = event.detail.apiResponse.contact_form_title
			? event.detail.apiResponse.contact_form_title
			: 'WPCF7';
		ga('send', 'event', 'Form Submission', 'Submit', formTitle);

		if (event.detail.apiResponse.cf7_redirect_url) {
			setTimeout(() => {
				window.location = event.detail.apiResponse.cf7_redirect_url;
			}, 1000);
		}
	}, false);

	// Cookie perferences
	jQuery('a.manage-cookies').on('click', (e) => {
		e.preventDefault();
		CookieControl.open();
	});

	// Track anchor link clicks
	jQuery('body').on('click', 'a', (e) => {
		// console.log(e.target);
		if (typeof (window.ga) === 'function') {

			const href = e.target.getAttribute('href');
			if (typeof href !== 'undefined' && href !== false) {
			const url = href.split(/[?#]/)[0];

			// Email links
			if (url.substr(0, 6) === 'mailto') {
				infotexAnalyticsEvent('Mailto link', 'click', url.substr(7), document.location.href);
			}

			// External links
			if (isExternal(url)) {
				infotexAnalyticsEvent('External link', 'click', url, document.location.href);
			}
			}
		}
	});
}

/**
 * Checks to see if a URL is different to the current domain
 * @see https://stackoverflow.com/questions/6238351/fastest-way-to-detect-external-urls#answer-6238456
 * @param string url - The url to test
 * @return bool
 */
 function isExternal(url) {
	const match = url.match(/^([^:/?#]+:)?(?:\/\/([^/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
	if (typeof match[1] === 'string' && match[1].length > 0 && match[1].toLowerCase() !== window.location.protocol) {
	  return true;
	}

	const protoStr = { 'http:': 80, 'https:': 443 }[window.location.protocol];
	if (typeof match[2] === 'string' && match[2].length > 0 && match[2].replace(new RegExp(`:(${protoStr})?$`), '') !== window.location.host) {
	  return true;
	}
	return false;
  }

/* global ga gtag */

/**
 * Fires a Google Analytics event for either gtag or ga framework
 * @param string category
 * @param string action
 * @param string label
 * @param int value
 * @return void
 */
 function infotexAnalyticsEvent(category, action, label, val) {
	if (window.gtag) {
	  // https://developers.google.com/analytics/devguides/collection/gtagjs/events
	  gtag('event', action, {
		event_category: category,
		event_label: label,
		value: val,
	  });
	} else if (window.ga) {
	  // https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	  ga('send', 'event', category, action, label, 1);
	}
  }
